import React from 'react';
import MainLayout from 'features/shared/layouts/main';
import Courses from 'features/courses';

const Page = () => (
  <MainLayout>
    <Courses />
  </MainLayout>
);

export default Page;
